<template>
  <div class="flex-column a-center j-center bg-white">
    <span class="ai-animate main-txt" swiper-animate-effect="fadeInDown" swiper-animate-delay="0" swiper-animate-speed="1_5">老师的听说智能教学助手</span>
    <div class="row w-1050 m-b-40">
      <div class="ai-animate line-chunk pull-left flex-column a-center j-around" swiper-animate-effect="fadeInLeft" swiper-animate-speed="1_5" swiper-animate-delay="0_5">
        模考全流程完美支持
        <img src="../assets/module-4-1.png">
        <div class="flex-wrap w-400">
          <div class="flex a-center j-center m-b-10 w-half fs-18" v-for="(item, idx) in subs[0]" :key="`subs-0-${idx}`">
            <v-icon name="check-circle" :class="item.theme" class="m-r-5"/>
            {{item.label}}
          </div>
        </div>
      </div>
    </div>
    <div class="row w-1050">
      <div class="ai-animate line-chunk pull-right flex-column a-center j-around" swiper-animate-effect="fadeInRight" swiper-animate-speed="1_5" swiper-animate-delay="0_5">
        学情动态一键掌握
        <img src="../assets/module-4-2.png" class="m-l-30">
        <div class="flex-wrap w-400">
          <div class="flex a-center j-center m-b-10 w-half fs-18" v-for="(item, idx) in subs[1]" :key="`subs-1-${idx}`">
            <v-icon name="check-circle" :class="item.theme" class="m-r-5"/>
            {{item.label}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      subs: {
        0: [
          {
            theme: 'text-blue',
            label: '考试专家审核题目'
          },
          {
            theme: 'text-yellow',
            label: '全真模拟机房考试'
          },
          {
            theme: 'text-green',
            label: '真实还原机考场景'
          },
          {
            theme: 'text-perpule',
            label: '语音评测准确可靠'
          },
        ],
        1: [
          {
            theme: 'text-blue',
            label: '贴近中考评分维度'
          },
          {
            theme: 'text-yellow',
            label: '集成笔试成绩统计'
          },
          {
            theme: 'text-green',
            label: '提供学生作答明细'
          },
          {
            theme: 'text-perpule',
            label: '班级学情一键掌握'
          },
        ]
      }
    }
  }  
}
</script>

<style lang="scss" scoped>
.main-txt {
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 40px;
}

.w-550 {
  width: 550px;
}
.w-1050 {
  width: 1050px;
}

.text-perpule {
  color: #979CFF;
}

.line-chunk {
  width: 500px;
  height: 350px;
  padding: 15px 0;
  background:rgba(255,255,255,1);
  box-shadow: 0px 2px 40px 0px rgba(241,241,241,1);
  border-radius: 8px;
  font-size: 24px;
  font-weight: 400;
  img {
    width: 148px;
  }
}
@media (max-width: 1024px) {
  .w-1050 {
    width: 100%;
    padding: 0 40px
  }
}
@media (max-width: 767px) {
  .main-txt {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .w-1050 {
    width: 100%;
    padding: 0 20px;
  }
  .m-b-40 {
    margin-bottom: 10px
  }
  .w-400 {
    width: 100%;
  }
  .line-chunk {
    width: 100%;
    height: auto;
    padding: 5px 0;
    font-size: 20px;
    img {
      width: 120px;
    }
  }
  .fs-18 {
    font-size: 14px;
  }
}
</style>
